<template>
  <page-content-sidebar-wrapper
    class="page-content"
    :class="{
      'page-content--bg-shade': bgShade,
      'page-content--bg-shade-for-mobile': bgShadeForMobile,
    }"
    :menu-title="menuTitle"
    :is-background-gray="isBackgroundGray"
    :off-scroll-zone-class="offScrollZoneClass"
    :is-force-sidebar-collapsed="isForceSidebarCollapsed"
    :sidebar-width="sidebarWidth"
    :no-scroll="noScroll"
    :stable-scrollbar-gutter="stableScrollbarGutter"
  >
    <page-content-default-wrapper
      :title="title"
      :no-padding="noPadding"
      :no-bottom-padding="noBottomPadding"
      :no-top-content="noTopContent"
      :full-scroll-height="fullScrollHeight"
      :size="size"
    >
      <template v-slot:title>
        <slot name="title" />
      </template>

      <template v-slot:page-content-top-right>
        <slot name="page-content-top-right" />
      </template>

      <slot />
    </page-content-default-wrapper>

    <template v-slot:after-sidebar-title>
      <slot name="after-sidebar-title" />
    </template>

    <template
      v-if="$slots.menu"
      v-slot:menu="{ onLockSidebar }"
    >
      <slot
        name="menu"
        :on-lock-sidebar="onLockSidebar"
      />
    </template>
  </page-content-sidebar-wrapper>
</template>

<script setup lang="ts">
import PageContentSidebarWrapper from '@/components/layout/pageContent/PageContentSidebarWrapper.vue'
import PageContentDefaultWrapper from '@/components/layout/pageContent/PageContentDefaultWrapper.vue'
import { SettingsPageTeleportTarget } from '@/components/shared/forms/const'
import type { PageContentMainSize } from '@/components/layout/pageContent/PageContentMain.vue'

type PageContentProps = {
  title?: string
  menuTitle?: string
  size?: PageContentMainSize
  noPadding?: boolean
  noBottomPadding?: boolean
  noTopContent?: boolean
  fullScrollHeight?: boolean
  bgShade?: boolean
  bgShadeForMobile?: boolean
  isBackgroundGray?: boolean
  offScrollZoneClass?: string
  isForceSidebarCollapsed?: boolean
  sidebarWidth?: number
  noScroll?: boolean
  stableScrollbarGutter?: boolean
}

withDefaults(defineProps<PageContentProps>(), { offScrollZoneClass: SettingsPageTeleportTarget })
</script>

<style lang="scss" scoped>
.page-content {
  &--bg-shade {
    @include media-md-min {
      background: $shade;
      --tm-resolver-failed-bg-color: $shade;
    }
  }
  &--bg-shade-for-mobile {
    background: $shade;
  }
}
</style>
